import React from "react";

/* eslint-disable max-len */
export default function SlidePrevIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={20} height={40} viewBox="0 0 20 40">
            <path d="M20 37.5L17.777 40 0 20 17.777 0 20 2.5 4.445 20z" fill="#fff" />
        </svg>
    );
}
